import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59839fec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "creator-list-item" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = { class: "avatar" }
const _hoisted_4 = {
  key: 0,
  class: "material-icons admin p-absolute",
  title: "Admin"
}
const _hoisted_5 = { class: "info" }
const _hoisted_6 = { class: "name" }
const _hoisted_7 = {
  key: 0,
  class: "stats"
}
const _hoisted_8 = { class: "subs" }
const _hoisted_9 = { class: "link" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-right" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserPhoto = _resolveComponent("UserPhoto")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_UserPhoto, {
          user: $props.user,
          style: {"width":"100%","height":"100%"}
        }, null, 8, ["user"])
      ]),
      ($props.user.isAdmin())
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, "verified"))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString($props.user.name), 1),
        ($props.user?.youtube?.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString($setup.calculateFollowers($props.user?.youtube)) + " followers", 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_router_link, {
        to: { name: 'creator', params: { creatorID: $props.user.id } }
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Go to profile "),
          _hoisted_10
        ]),
        _: 1
      }, 8, ["to"])
    ])
  ]))
}